import { Box, Typography, useMediaQuery } from '@mui/material';
import { useIsFetching } from '@tanstack/react-query';
import { memo } from 'react';

import { Loader } from './Backdrop';

interface HeaderProps {
  title: string;
  subtitle?: string;
  loading?: boolean;
}

const Header = memo(({ title, subtitle, loading = false }: HeaderProps) => {
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  const isFetching = useIsFetching();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      flexWrap="wrap"
      textAlign={isSmallScreen ? 'center' : 'left'}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={isSmallScreen ? 'center' : 'start'}
        position="relative"
        gap={0.5}
      >
        <Typography
          variant="h1"
          fontWeight="bold"
          sx={{ position: 'relative' }}
        >
          {title}
        </Typography>
        {loading || isFetching ? <Loader size="sm" /> : null}
      </Box>
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
    </Box>
  );
});

Header.displayName = 'Header';

export default Header;
